import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, TextField,
  Item, Tabs, TabPanels, TabList, ActionButton, Key, Divider } from '@adobe/react-spectrum';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import ZipCodeDropDown from '../formComponents/ZipCodeDropDown';
import { useDependency } from '../../../../../contexts/DependencyProvider';
import { ListRegionRequest } from '../../../../../services/soap/translate/reqeusts/ListRegionRequest';
import { ListCountryRequest } from '../../../../../services/soap/translate/reqeusts/ListCountryRequest';
import { ListCityRequest } from '../../../../../services/soap/translate/reqeusts/ListCityRequest';
import CityDropDown from '../formComponents/CityDropDown';
import RegionDropDown from '../formComponents/RegionDropDown';
import CountriesDropDown from '../formComponents/CountriesDropDown';
import { Check, ExclamationTriangle } from 'react-bootstrap-icons';
import { useViewInfo } from '../../../../../hooks/UseViewInfo';
import { ListZipRequest } from '../../../../../services/soap/translate/reqeusts/ListZipRequest';
import { useTranslation } from 'react-i18next';

interface IAddressSectionProps {
  addresses: ContactFormData['addresses'];
  street?: string;
  city?: string;
  zip?: string;
  onChange: (addresses: ContactFormData['addresses']) => void;
  validationErrors: any;
  setValidationErrors: (data: any) => void;
  expandedSectionKey: any;
  setExpandedSectionKey: (data: any) => void;
  fieldConfig: any;
  validationStatus: any;
  setValidationStatus: (data: any) => void;
  addressType?: string;
}

export const AddressSection: React.FC<IAddressSectionProps> = ({
  addresses,
  street,
  city,
  zip,
  onChange,
  expandedSectionKey,
  setExpandedSectionKey,
  fieldConfig,
  validationStatus,
  setValidationStatus,
  validationErrors,
  setValidationErrors,
  addressType
}) => {
  const { store, translateService } = useDependency();
  const { isMobile } = useViewInfo();
  const [isSectionRequired, setIsSectionRequired] = useState(false);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
  const [isCityExist, setIsCityExist] = useState(false);
  const inputRefs = useRef<any[]>([]);
  const { t } = useTranslation('contacts');
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  const _message = (key: string) => t(`contact_messages.${key}`, { ns: 'contacts' });

  // Helpers for cross-tab validation
  const isFilled = (v?: string) => typeof v === 'string' && v.trim() !== '';
  const anyFilled = (field: 'zip' | 'city' | 'region' | 'country') =>
    Array.isArray(addresses) && addresses.some(a => isFilled((a as any)?.[field]));

  // Cross-tab section validity
  useEffect(() => {
    if (addresses.length > 0) {
      const zipOk = !fieldConfig?.zip?.required || anyFilled('zip');
      const cityOk = !fieldConfig?.city?.required || anyFilled('city');
      const regionOk = !fieldConfig?.region?.required || anyFilled('region');
      const countryOk = !fieldConfig?.country?.required || anyFilled('country');

      const allValid = zipOk && cityOk && regionOk && countryOk;

      setIsConfirmDisabled(!allValid);
      setValidationStatus((prev: any) => ({ ...prev, ['addressSection']: allValid }));
    } else {
      if (
        fieldConfig?.zip?.required ||
        fieldConfig?.city?.required ||
        fieldConfig?.region?.required ||
        fieldConfig?.country?.required
      ) {
        setValidationStatus((prev: any) => ({ ...prev, ['addressSection']: false }));
        setIsSectionRequired(true);
      }
    }
  }, [addresses, fieldConfig, setValidationStatus]);

  const handleZipChange = async (zipVal: string, cityId: string, index: number, address: any) => {
    const newAddresses = [...addresses];
    const currentCity = await translateService.listCity(
      new ListCityRequest(store.Server, store.SessionId, { cityId: cityId })
    );
    if (currentCity.ROWS.ROW.length > 0) {
      const { city, cityName } = currentCity.ROWS.ROW[0];
      const currentRegion = await translateService.listRegion(
        new ListRegionRequest(store.Server, store.SessionId, { regionId: currentCity.ROWS.ROW[0].region })
      );
      if (currentRegion.ROWS.ROW.length > 0) {
        const { region, country } = currentRegion.ROWS.ROW[0];
        const countries = await translateService.listCountry(
          new ListCountryRequest(store.Server, store.SessionId, { countryId: country })
        );
        if (countries.ROWS.ROW.length > 0) {
          const { country: ctry } = countries.ROWS.ROW[0];
          newAddresses[index] = { ...address, zip: zipVal, city, region, country: ctry };
          onChange(newAddresses);
        }
      }
    }
  };

  // const bindInvoiceAddress = async () => {
  //   const deliveryAddressIndex = addresses.findIndex(a => a.type === '132018101');
  //   const invoiceAddressIndex = addresses.findIndex(a => a.type === '132016101');

  //   if (deliveryAddressIndex !== -1 && invoiceAddressIndex !== -1) {
  //     const newAddresses = [...addresses];
  //     if (city !== '') {
  //       const currentCity = await translateService.listCity(
  //         new ListCityRequest(store.Server, store.SessionId, { cityName: city })
  //       );
  //       if (currentCity && currentCity.ROWS && currentCity.ROWS.ROW.length > 0) {
  //         setIsCityExist(true);
  //         const { cityId } = currentCity.ROWS.ROW[0];
  //         const currentZip = await translateService.listZip(
  //           new ListZipRequest(store.Server, store.SessionId, { zipName: zip, cityName: city })
  //         );
  //         const zipId = currentZip && currentZip.ROWS && currentZip.ROWS.ROW.length > 0 ? currentZip.ROWS.ROW[0].zip : zip;
  //         const updatedInvoiceAddress = {
  //           ...newAddresses[invoiceAddressIndex],
  //           zip: zipId || '',
  //           city: city || '',
  //           street: street || ''
  //         };
  //         newAddresses[invoiceAddressIndex] = updatedInvoiceAddress;
  //         onChange(newAddresses);
  //         handleZipChange(updatedInvoiceAddress.zip, cityId, invoiceAddressIndex, updatedInvoiceAddress);
  //       } else {
  //         setIsCityExist(false);
  //         setSelectedTab('0');
  //       }
  //     } else {
  //       const updatedInvoiceAddress = {
  //         ...newAddresses[invoiceAddressIndex],
  //         zip: '',
  //         city: '',
  //         street: '',
  //         country: '',
  //         region: ''
  //       };
  //       newAddresses[invoiceAddressIndex] = updatedInvoiceAddress;
  //       onChange(newAddresses);
  //     }
  //   }
  // };
  // Replace your existing bindInvoiceAddress with this:
// Drop-in: resolves "invoice" tab without hard-coded IDs and ensures string types for IDs.
const loadInvoiceAddress = async () => {
  const toStr = (v: any) => (v === undefined || v === null ? '' : String(v));
  const norm = (s?: string) => (s ?? '').toLowerCase().trim();
  const anyMatch = (val: string | undefined, needles: string[]) =>
    !!val && needles.includes(norm(val));

  try {
    if (!Array.isArray(addresses) || addresses.length === 0) return;

    // --- Resolve "invoice" and "delivery" indices without hard-coded IDs ---
    const invoiceNames = [
      t('contact_common.invoice_address', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.invoice', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.billing_address', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.billing', { ns: 'contacts', defaultValue: '' }),
      'invoice',
      'billing'
    ].filter(Boolean).map(norm);

    const deliveryNames = [
      t('contact_common.delivery_address', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.shipping_address', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.delivery', { ns: 'contacts', defaultValue: '' }),
      t('contact_common.shipping', { ns: 'contacts', defaultValue: '' }),
      'delivery',
      'shipping'
    ].filter(Boolean).map(norm);

    const mapTypeId = (role: 'invoice' | 'delivery') => fieldConfig?.addressTypes?.[role];

    const resolveIndex = (role: 'invoice' | 'delivery') => {
      const needles = role === 'invoice' ? invoiceNames : deliveryNames;
      const pref = mapTypeId(role);
      if (pref) {
        const viaType = addresses.findIndex(a => String((a as any)?.type) === String(pref));
        if (viaType !== -1) return viaType;
      }
      const viaName = addresses.findIndex(a => {
        const candidates = [
          norm((a as any)?.name),
          norm((a as any)?.typeName),
          norm((a as any)?.label),
          norm((a as any)?.code),
        ];
        return candidates.some(c => anyMatch(c, needles));
      });
      if (viaName !== -1) return viaName;

      if (role === 'invoice') {
        const viaFlag = addresses.findIndex((a: any) => a?.isInvoice === true || a?.billing === true);
        if (viaFlag !== -1) return viaFlag;
      } else {
        const viaFlag = addresses.findIndex((a: any) => a?.isDelivery === true || a?.shipping === true);
        if (viaFlag !== -1) return viaFlag;
      }

      // Safe fallback: invoice → second if exists else first; delivery → first
      if (role === 'invoice') return addresses.length > 1 ? 1 : 0;
      return 0;
    };

    let deliveryIndex = resolveIndex('delivery');
    let invoiceIndex = resolveIndex('invoice');

    // Clamp indices to valid range to avoid "vanish" due to invalid selectedKey
    const clamp = (i: number) => Math.max(0, Math.min(i, addresses.length - 1));
    deliveryIndex = clamp(deliveryIndex);
    invoiceIndex = clamp(invoiceIndex);

    const newAddresses = [...addresses];

    // No input city ⇒ clear invoice and select a valid tab
    if (!city || city.trim() === '') {
      newAddresses[invoiceIndex] = {
        ...newAddresses[invoiceIndex],
        zip: '',
        city: '',
        street: '',
        region: '',
        country: '',
      };
      onChange(newAddresses);
      setSelectedTab(String(clamp(deliveryIndex)));
      return;
    }

    // --- Dictionary lookups (guard each step) ---
    const cityResp: any = await translateService.listCity(
      new ListCityRequest(store.Server, store.SessionId, { cityName: city })
    );

    if (cityResp?.ROWS?.ROW?.length > 0) {
      setIsCityExist(true);
      const cRow = cityResp.ROWS.ROW[0];
      const cityId = toStr(cRow.cityId ?? cRow.city ?? cRow.id);

      const zipResp: any = await translateService.listZip(
        new ListZipRequest(store.Server, store.SessionId, { zipName: zip, cityName: city })
      );
      const zipId = toStr(zipResp?.ROWS?.ROW?.[0]?.zip ?? zip);

      let regionId = '';
      let countryId = '';

      const regionKey = cRow.region ?? cRow.regionId;
      if (regionKey !== undefined && regionKey !== null) {
        const regionResp: any = await translateService.listRegion(
          new ListRegionRequest(store.Server, store.SessionId, { regionId: regionKey })
        );
        if (regionResp?.ROWS?.ROW?.length > 0) {
          const rRow = regionResp.ROWS.ROW[0];
          regionId = toStr(rRow.region ?? rRow.regionId);

          const countryKey = rRow.country ?? rRow.countryId;
          if (countryKey !== undefined && countryKey !== null) {
            const countryResp: any = await translateService.listCountry(
              new ListCountryRequest(store.Server, store.SessionId, { countryId: countryKey })
            );
            if (countryResp?.ROWS?.ROW?.length > 0) {
              const k = countryResp.ROWS.ROW[0];
              countryId = toStr(k.country ?? k.countryId);
            }
          }
        }
      }

      // Update only invoice tab; keep others intact. Force all IDs to strings.
      newAddresses[invoiceIndex] = {
        ...newAddresses[invoiceIndex],
        zip: toStr(zipId),
        city: toStr(cityId),
        street: toStr(street),
        region: toStr(regionId),
        country: toStr(countryId),
      };

      onChange(newAddresses);
      // Ensure we select an existing tab key
      setSelectedTab(String(clamp(invoiceIndex)));
    } else {
      // City not in dictionary—copy raw values safely
      setIsCityExist(false);
      newAddresses[invoiceIndex] = {
        ...newAddresses[invoiceIndex],
        zip: toStr(zip),
        city: '',          // unknown canonical ID
        street: toStr(street),
        region: '',
        country: '',
      };
      onChange(newAddresses);
      setSelectedTab(String(clamp(deliveryIndex)));
    }
  } catch (e) {
    // Fail-safe: never crash the render; keep UI visible
    console.error('loadInvoiceAddress error:', e);
    // Do not change addresses on error; optionally keep current tab
  }
};


  useEffect(() => {
    if (addressType === 'company') {
      loadInvoiceAddress();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey: any) => (prevKey.has('addressSection') ? new Set() : new Set(['addressSection'])));
  };

  const handleConfirm = () => {
    const errors: any = {};

    if (fieldConfig?.zip?.required && !anyFilled('zip')) errors.zip = _message(`zip_required`);
    if (fieldConfig?.city?.required && !anyFilled('city')) errors.city = _message(`city_required`);
    if (fieldConfig?.region?.required && !anyFilled('region')) errors.region = _message(`region_required`);
    if (fieldConfig?.country?.required && !anyFilled('country')) errors.country = _message(`country_required`);

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setValidationStatus((prev: any) => ({ ...prev, addressSection: false }));
      return;
    }

    setValidationErrors({});
    setValidationStatus((prev: any) => ({ ...prev, addressSection: true }));
    setExpandedSectionKey(new Set(['contactSection']));
  };

  const validaterequiredFields = () => {
    const errors: any = {};
    if (fieldConfig?.zip?.required && !anyFilled('zip')) errors.zip = _message(`zip_required`);
    if (fieldConfig?.city?.required && !anyFilled('city')) errors.city = _message(`city_required`);
    if (fieldConfig?.region?.required && !anyFilled('region')) errors.region = _message(`region_required`);
    if (fieldConfig?.country?.required && !anyFilled('country')) errors.country = _message(`country_required`);

    setValidationErrors(errors);
    setValidationStatus((prev: any) => ({ ...prev, addressSection: Object.keys(errors).length === 0 }));
  };

  const [selectedTab, setSelectedTab] = useState<Key>('0');

  const handleTabChange = (key: Key) => {
    setSelectedTab(key);
  };

  useEffect(() => {
    setTimeout(() => {
      if (city !== '' && addressType === 'company' && isCityExist) {
        setSelectedTab('1');
      } else {
        setSelectedTab('0');
      }
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedSectionKey]);

  useEffect(() => {
    inputRefs.current = addresses.map((_, i) => inputRefs.current[i] || React.createRef());
  }, [addresses]);

  useEffect(() => {
    setTimeout(() => {
      const idx = Number(selectedTab);
      if (!isNaN(idx) && inputRefs.current[idx] && inputRefs.current[idx].current) {
        inputRefs.current[idx].current.focus();
      }
    }, 1000);
  }, [expandedSectionKey, selectedTab]);

  return (
    <Accordion expandedKeys={expandedSectionKey} isQuiet onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id={'addressSection'}>
        <DisclosureTitle UNSAFE_style={{ paddingBlock: 0 }}>
          <Flex justifyContent="space-between" alignItems="center" width="100%">
            <View>
              <span>{`${_tt('address')}`}</span>
              <span style={{ color: '#B0BEC5', fontFamily: 'Adobe Clean' }}>
                {isSectionRequired && ` (${_tt('required')})`}
              </span>
            </View>
            {validationStatus.addressSection ? (
              <Check size={20} color="#1976D2" />
            ) : (
              <ExclamationTriangle size={20} color="#FF9800" />
            )}
          </Flex>
        </DisclosureTitle>
        <DisclosurePanel>
          <Divider size="M" UNSAFE_style={{ marginBottom: 10 }} />
          {expandedSectionKey.has('addressSection') && addresses.length > 0 && (
            <Tabs
              selectedKey={selectedTab}
              onSelectionChange={handleTabChange}
              aria-label="Address Tabs orientation"
              orientation={isMobile ? 'horizontal' : 'vertical'}
            >
              <TabList>
                {addresses.map((address, index) => (
                  <Item key={index}>{address.name}</Item>
                ))}
              </TabList>
              <TabPanels>
                {addresses.map((address, index) => (
                  <Item key={index}>
                    <Flex direction="column" gap="size-100" width="100%">
                      <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                        <TextField
                          ref={inputRefs.current[index]}
                          label={_tt('street')}
                          aria-label={_tt('Street')}
                          value={address.street}
                          onChange={(streetVal: any) => {
                            const newAddresses = [...addresses];
                            newAddresses[index] = { ...address, street: streetVal };
                            onChange(newAddresses);
                          }}
                          onBlur={() => validaterequiredFields()}
                          width={{ base: '100%', L: '70%' }}
                        />
                        <ZipCodeDropDown
                          selectedZip={address.zip}
                          onChange={(data) => {
                            const { zip, cityName, city } = data;
                            handleZipChange(zip, city, index, address);
                          }}
                          onBlur={() => validaterequiredFields()}
                          isRequired={fieldConfig?.zip?.required}
                          errorMessage={fieldConfig?.zip?.required && validationErrors.zip}
                          validationState={
                            fieldConfig?.zip?.required && validationErrors?.zip
                              ? address.zip === ''
                                ? 'invalid'
                                : 'valid'
                              : undefined
                          }
                        />
                      </Flex>
                      <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                        <CityDropDown
                          selectedCityId={address.city || ''}
                          onChange={(data) => {
                            const { cityName, city } = data;
                            const newAddresses = [...addresses];
                            newAddresses[index] = { ...address, city, cityName };
                            onChange(newAddresses);
                          }}
                          isRequired={fieldConfig?.city?.required}
                          errorMessage={fieldConfig?.city?.required && validationErrors.city}
                          validationState={
                            fieldConfig?.city?.required && validationErrors?.city
                              ? address.city === ''
                                ? 'invalid'
                                : 'valid'
                              : undefined
                          }
                        />
                        <RegionDropDown
                          selectedRegion={address.region || ''}
                          onChange={(data) => {
                            const { region, regionName } = data;
                            const newAddresses = [...addresses];
                            newAddresses[index] = { ...address, region, regionName };
                            onChange(newAddresses);
                          }}
                          isRequired={fieldConfig?.region?.required}
                          errorMessage={fieldConfig?.region?.required && validationErrors.region}
                          validationState={
                            fieldConfig?.region?.required && validationErrors?.region
                              ? address.region === ''
                                ? 'invalid'
                                : 'valid'
                              : undefined
                          }
                        />
                        <CountriesDropDown
                          selectedCountryId={address.country || ''}
                          onChange={(data) => {
                            const { country, countryName } = data;
                            const newAddresses = [...addresses];
                            newAddresses[index] = { ...address, country: country.toString() };
                            onChange(newAddresses);
                          }}
                          isRequired={fieldConfig?.country?.required}
                          errorMessage={fieldConfig?.country?.required && validationErrors.country}
                          validationState={
                            fieldConfig?.country?.required && validationErrors?.country
                              ? address.country === ''
                                ? 'invalid'
                                : 'valid'
                              : undefined
                          }
                        />
                      </Flex>
                    </Flex>
                  </Item>
                ))}
              </TabPanels>
            </Tabs>
          )}
          <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
            <ActionButton
              isDisabled={isConfirmDisabled}
              onPress={handleConfirm}
              isQuiet
              UNSAFE_style={{ color: isConfirmDisabled ? '#B0BEC5' : '#1976D2', padding: 10 }}
            >
              <Check size={22} />
              {_tt('button_confirm')}
            </ActionButton>
          </Flex>
          <Divider size="M" UNSAFE_style={{ marginTop: 10 }} />
        </DisclosurePanel>
      </Disclosure>
    </Accordion>
  );
};
